export class APY {
    constructor(hpy) {
        /**
         * hourly percentage yield in dollars
         */
        this._hpy = 0;
        this._hpy = hpy;
    }
    static getBoundedMpy(apy, defaultVal = 0.1) {
        let mpy = (apy === null || apy === void 0 ? void 0 : apy.mpy()) || defaultVal;
        if (mpy == Infinity) {
            mpy = defaultVal;
        }
        return mpy;
    }
    static toPercentage(value) {
        return `${(value * 100).toFixed(2)} %`;
    }
    hpy() {
        return this._hpy;
    }
    dpy() {
        return this.hpy() * 24;
    }
    wpy() {
        return this.hpy() * 24 * 7;
    }
    mpy() {
        return this.hpy() * 24 * 30;
    }
    apy() {
        return this.hpy() * 24 * 365;
    }
    hpyFormatted() {
        return APY.toPercentage(this.hpy());
    }
    dpyFormatted() {
        return APY.toPercentage(this.dpy());
    }
    wpyFormatted() {
        return APY.toPercentage(this.wpy());
    }
    mpyFormatted() {
        return APY.toPercentage(this.mpy());
    }
    apyFormatted() {
        return APY.toPercentage(this.apy());
    }
}
/**
 * calculate hourly percentage yield in usd dollars
 * of a given asset that yields x wax per Aether per Hour
 */
export function getAPY(waxPerAH, waxInUsd, prices) {
    const aethInWax = prices.AETHER;
    const aethInUsd = aethInWax * waxInUsd;
    // this gives how many dollars you need to invest
    // in order to get 1 dollar of yield per hour, we are
    // interested in the inverse
    const inverseHpy = (waxPerAH * waxInUsd) / aethInUsd;
    const hpy = 1 / inverseHpy;
    return new APY(hpy);
}
